import Vue from "vue";
import VueCryptojs from 'vue-cryptojs'
import VueJwtDecode from 'vue-jwt-decode'
Vue.use(VueCryptojs);

export const state = {
    userAccessList(){
        if(!localStorage.getItem("userAccess")) return [];
        let encryptedText = localStorage.getItem("userAccess");
        if(encryptedText === '') return [];
        var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
        var key = Vue.CryptoJS.enc.Latin1.parse("$b14cA5898a4e4142@@@2ea2143a2410");
        var plaintextData = Vue.CryptoJS.AES.decrypt(
            { ciphertext: rawData },
            key,
            {
                iv: Vue.CryptoJS.enc.Latin1.parse(
                    ""
                ),
            }
        );
        var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);
        return JSON.parse(plaintext).AccessList;
    },
    campusAccessList(){
        if(!localStorage.getItem("campusAccess")) return [];
        let encryptedText = localStorage.getItem("campusAccess");
        var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
        var key = Vue.CryptoJS.enc.Latin1.parse("$b14cA5898a4e4142@@@2ea2143a2410");
        var plaintextData = Vue.CryptoJS.AES.decrypt(
            { ciphertext: rawData },
            key,
            {
                iv: Vue.CryptoJS.enc.Latin1.parse(
                    ""
                ),
            }
        );
        var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);
        return JSON.parse(plaintext)
    },
    isAdmin(){
        // if(localStorage.getItem("accessToken") === null) return false;
        // var plaintext = VueJwtDecode.decode(localStorage.getItem("accessToken"));
        // return plaintext.IsAdmin.toLowerCase() === "true" ? true : false;
        if(!localStorage.getItem("userAccess")) return [];
        let encryptedText = localStorage.getItem("userAccess");
        if(encryptedText === '') return [];
        var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
        var key = Vue.CryptoJS.enc.Latin1.parse("$b14cA5898a4e4142@@@2ea2143a2410");
        var plaintextData = Vue.CryptoJS.AES.decrypt(
            { ciphertext: rawData },
            key,
            {
                iv: Vue.CryptoJS.enc.Latin1.parse(
                    ""
                ),
            }
        );
        var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);
        return JSON.parse(plaintext).IsAdmin;
    },
    getToken(){
        if(!localStorage.getItem("userAccess")) return [];
        let encryptedText = localStorage.getItem("userAccess");
        if(encryptedText === '') return [];
        var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
        var key = Vue.CryptoJS.enc.Latin1.parse("$b14cA5898a4e4142@@@2ea2143a2410");
        var plaintextData = Vue.CryptoJS.AES.decrypt(
            { ciphertext: rawData },
            key,
            {
                iv: Vue.CryptoJS.enc.Latin1.parse(
                    ""
                ),
            }
        );
        var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);
        return JSON.parse(plaintext);
    }
}